import React, { useEffect } from "react";
import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import Header from "./Header";
import Sidebar, { drawerWidth, DrawerHeader } from "./Sidebar";
import { onMessage } from "firebase/messaging";
import { messaging } from "../firebase";
import toast from "react-hot-toast";
import { Toaster } from "react-hot-toast";

export default function MainLayout({ children }) {
  const [open, setOpen] = React.useState(false);

  const handleDrawerOpen = () => {
    setOpen(true);
  };
  const handleDrawerClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    const unsubscribe = onMessage(messaging, (payload) => {
      const message =
        payload?.notification?.body ||
        payload?.data?.body ||
        "New message received";

      toast(message);
    });

    return unsubscribe;
  }, []);
  return (
    <>
      <Toaster position="top-left" />
      <Box sx={{ display: "flex" }}>
        <CssBaseline />
        <Header
          open={open}
          handleDrawerOpen={handleDrawerOpen}
          drawerWidth={drawerWidth}
        />
        <Sidebar open={open} handleDrawerClose={handleDrawerClose} />

        <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
          <DrawerHeader />
          {children}
        </Box>
      </Box>
    </>
  );
}
